import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {Report} from '../../Interfaces/Report';
import {GlobalEventsManager} from '../../GlobalEventManager';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  clientRequest: ClientRequest;
  myUser = {} as User;
  subscription: Subscription;
  reportsArray: Report[];

  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService,private  globalEventsManager: GlobalEventsManager, public myApp:AppComponent) {
    this.myUser = this.myApp.user;
/*
        this.myUser = {} as User;
        this.myUser.active ="Y"
        this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
        this.myUser.address_2 = null
      //  this.myUser.company_code ="EGN"
        this.myUser.company_code ="M0995"
        this.myUser.company_name= "MAHER TERMINALS, LLC"
        this.myUser.city= "HOUSTON"
        this.myUser.email_address= "cc@dom.com"
        this.myUser.fax_number= "9082373221"
        this.myUser.first_name= "Craig"
        this.myUser.last_name= "Miller"
        this.myUser. maherError= null
        this.myUser.old_password= null
        this.myUser.password= null;
        this.myUser.phone_number= "908338922"
        this.myUser.company_scac= null
        this.myUser.state= "TX"
        this.myUser.userMenuReportItemsView= null
        this.myUser.user_gkey= "8237887"
         this.myUser.role= "AGENT"
      //  this.myUser.role= "LINEOP"
        //this.myUser.role= "HAULIER"
        this.myUser.username="CDOUG"
        this.myUser.zip="07201"
        this.myUser.canSeeAllData = "0";



 */



  }


  ngOnInit() {
    this.getReports();
  }


  getReports(){

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.requestData = [];
    this.clientRequest.user = this.myUser;
    const lhsUserObs$ = this.queryService.getReports(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (reps) => {
        this.reportsArray = reps;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.reportsArray;

      });
  }

  generateReport(urlIn: string){
    window.open(urlIn, "_blank");
  }

}
